import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'wilson-view-file-popup',
  templateUrl: './view-file-popup.component.html',
  styleUrls: ['./view-file-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewFilePopupComponent {
  private modalService = inject(NgbModal);

  @Input() file!: string;
  @Input() name!: string;

  zoomIn = false;

  zoom() {
    this.zoomIn = !this.zoomIn;
  }

  close() {
    this.modalService.dismissAll();
  }
}
